<template>
  <div class="settings-panel">
    <HideRbac :permissions="['switchDatapeopleRole']">
      <DatapeopleRoleDropdown />
    </HideRbac>
    <HideRbac :permissions="['switchJpRole']">
      <JpRoleDropdown />
    </HideRbac>
    <HideRbac :permissions="['forceNextUi']">
      <v-btn
        :active="authData.nextUiEnabled"
        class="text-textDark opacity-10"
        variant="flat"
        :width="40"
        :min-width="40"
        height="40"
        title="Next UI"
        @click="toggleNextUi"
      >
        [N]
      </v-btn>
    </HideRbac>
    <AccountDropdown
      v-bind="$attrs"
      @tracking-event="$emit('tracking-event', $event)"
    />
  </div>
</template>

<script>
import AccountDropdown from '@/components/settings/AccountDropdown.vue';
import HideRbac from '@/components/rbac/HideRbac.vue';
import JpRoleDropdown from '@/components/navbar/JpRoleDropdown.vue';
import DatapeopleRoleDropdown from '@/components/navbar/DatapeopleRoleDropdown.vue';
import { useAppAuthData } from '@/stores/app/authData';
import { mapState } from 'pinia';

export default {
  name: 'SettingsPanel',
  components: {
    AccountDropdown,
    HideRbac,
    JpRoleDropdown,
    DatapeopleRoleDropdown,
  },
  emits: ['tracking-event'],
  computed: {
    ...mapState(useAppAuthData, ['authData']),
  },
  methods: {
    toggleNextUi() {
      useAppAuthData().toggleNextUi();
    },
  },
};
</script>

<style scoped lang="less">
.settings-panel {
  display: flex;
    & > *:not(:first-child) {
      margin-left: 8px;
    }
  .v-btn {
    font-size: 12px !important;
    font-weight: 300 !important;
    border: none;
    .v-btn:before {
      opacity: 0 !important;
    }
    .v-ripple__container {
      opacity: 0 !important;
    }
    &:hover {
      background-color: fade(@bg-brand-default, 5%);
      color: @text-brand;
    }
  }
}
</style>
